export enum DeviceBreakpoint {
  // mobile is up to 768px
  TABLET = 769,
  DESKTOP = 1216,
  WIDESCREEN = 1408
}
